/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.23/esri/copyright.txt for details.
*/
async function e(e,r){const{WhereClause:t}=await import("./sql/WhereClause.js");return t.create(e,r)}export{e as parseWhereClause};
